import {atom} from 'recoil'

export const rowsChosen = atom(
  {
    key: 'import-rowschosen',
    default: []
  }
)
